import React, { useContext } from "react";
import { CrateHint, SurplusBundleActions, SurplusCratesContext } from "./SurplusRack";
import { KioskScanContext } from "../features/laserKiosk/kioskScan";

// ─── Pieces an order still needs but has no spot for ──────────────────
// The API sends kind "owed" for pieces the home order (or an allocation's
// target) still needs when its packing plan has no room, is a Draft or
// doesn't exist yet, and for Bad Idea's own rider pieces. They are NOT
// surplus. Since 2026-10-26 (Mike: "same rack, own label") an order's owed
// pieces get an OWED label at Complete and go on the surplus rack, labelled
// for their order; they move to its pallet when JobQ says MOVE. Bad Idea
// stock pieces still auto-ship.
export function OwedCardBody({ dest }) {
  const { scanOn } = useContext(KioskScanContext);
  const cratesOn = useContext(SurplusCratesContext);
  const badIdea = dest.owed_kind === "bad_idea";
  return (
    <>
      <div style={{ display: "flex", alignItems: "baseline", gap: "0.8rem", marginBottom: "0.4rem", flexWrap: "wrap" }}>
        <span style={{
          background: "#c0392b", color: "white", padding: "0.25rem 0.7rem", borderRadius: 6,
          fontWeight: 700, fontSize: "1rem", textTransform: "uppercase", letterSpacing: "0.04em", whiteSpace: "nowrap",
        }}>NOT SURPLUS</span>
        <span style={{ color: "#ffb3a7", fontSize: "1.2rem", fontWeight: 700 }}>
          {badIdea ? "BAD IDEA STOCK" : `HOLD FOR ${dest.dest_so_number || "ITS ORDER"}`}
        </span>
      </div>
      <div style={{ fontSize: "5.8rem", fontWeight: 800, color: "#ffd2c9", fontFamily: "monospace", lineHeight: 1 }}>
        {dest.qty}
      </div>
      <div style={{ fontSize: "1.5rem", color: "#f2b8ad", marginTop: "0.3rem" }}>
        {badIdea ? "pieces for Bad Idea stock (they auto-ship)" : `pieces ${dest.dest_so_number || "this order"} still needs`}
      </div>
      {dest.dest_customer_name && !badIdea && (
        <div style={{ fontSize: "1.1rem", color: "#d9a79d" }}>{dest.dest_customer_name}</div>
      )}
      {dest.reason && (
        <div style={{ fontSize: "1.1rem", color: "#d9a79d" }}>No spot: {dest.reason}</div>
      )}
      {!badIdea && (
        <div style={{
          marginTop: "auto", background: "#5c1a14", border: "2px solid #e74c3c", borderRadius: 8,
          padding: "0.55rem 0.9rem", color: "#ffd2c9", fontWeight: 800, fontSize: "1.15rem",
        }}>
          {(dest.bundles || []).length && cratesOn
            ? `OWED label printed: stick it on, put them in their OWN crate (never with this part's surplus), ${scanOn ? "scan the crate's beacon or " : ""}click In crate. They go to ${dest.dest_so_number || "the order"}'s pallet only when JobQ says MOVE.`
            : (dest.bundles || []).length
            ? `OWED label printed: ${scanOn ? "scan it, stick it on, put them on the SURPLUS RACK" : "stick it on, put them on the SURPLUS RACK, click Labeled + racked"}. They go to ${dest.dest_so_number || "the order"}'s pallet only when JobQ says MOVE.`
            : "An OWED label prints at Complete: stick it on, put them on the SURPLUS RACK. NOT surplus: never allocate them elsewhere."}
        </div>
      )}
      {!badIdea && (dest.bundles || []).filter((b) => !b.racked).map((b) => (
        <div key={b.bundle_id} style={{ marginTop: "0.4rem" }}>
          <div style={{ fontSize: "1.05rem", color: "#ffd2c9", fontWeight: 700 }}>OWED #{b.bundle_id} · {b.qty} pcs</div>
          <CrateHint bundle={b} />
          <SurplusBundleActions bundle={b} />
        </div>
      ))}
    </>
  );
}
